export default __webpack_public_path__ + "static/media/breakfastKeto.1086e611.svg";